import { Component, OnInit, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs/operators';

import { ValidationErrors, NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Dealer } from '../../models/dealer.interface';
import { DealerService } from '../../../dealer/services/dealer.service';
import { DealerAccountData } from '../../models/dealer-account.interface';
import { Region } from '../../models/region.interface';
import { AbstractBiditComponent } from '../abstract.bidit.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DatePipe } from '@angular/common';
import { DateService } from '../../services/date.service';

@Component({
  selector: 'app-dealer-account',
  templateUrl: './dealer-account.component.html',
  styleUrls: ['./dealer-account.component.scss']
})
export class DealerAccountComponent extends AbstractBiditComponent {
  pageTitle: string = "Admin";
  isDealerAdmin: boolean = true;
  //timeAlert: string;

  dealer: Dealer;
  states: string[];
  regions: Region[];
  //times: string[];

  constructor(deviceDetectorService: DeviceDetectorService,
    private datepipe: DatePipe,
    private dealerService: DealerService,
    public dialogRef: MatDialogRef<DealerAccountComponent>,
    private dateService: DateService,
    @Inject(MAT_DIALOG_DATA) public data: DealerAccountData) {
    super(deviceDetectorService);
    //this.buildTimeList();
  }

  ngOnInit() {

    this.isDealerAdmin = this.data.isDealerAdmin;
    if (this.data.id == null) {
      this.dealer = {} as Dealer;
      this.dealer.dealer_IsActive = true;
      this.dealer.contractFillColor = "#18225f";
      this.dealer.contractFillColor = "#ffffff";
      this.dealer.contractLogoPosition = 1;
    }
    else if (this.isDealerAdmin) {
      this.dealerService.getDealerDetails()
        .subscribe({
          next: (data) => {
            this.dealer = data;
          },
          error: (error: string) => this.onError(error)
        });
    }
    else {
      this.dealerService.getDealer(this.data.id)
        .subscribe({
          next: (data) => {
            this.dealer = data;
            this.dealer.contractFillTextColor = this.dealer.contractFillTextColor ?? "#ffffff";
          },
          error: (error: string) => this.onError(error)
        });
    }

    this.dealerService.getStates()
      .subscribe({
        next: (data) => {
          this.states = data;
        },
        error: (error: string) => this.onError(error)
      });

    this.dealerService.getRegions()
      .subscribe({
        next: (data) => {
          this.regions = data;
        },
        error: (error: string) => this.onError(error)
      });
  }

  saveAccount(form: NgForm) {
    this.errors = '';
    //this.timeAlert = null;
    //let startTime = this.dealer.defaultWorkOrderStartTime;
    //let stopTime = this.dealer.defaultWorkOrderStopTime;

    if (form.valid) {
      this.isRequesting = true;

      //this.timeAlert = this.dateService.validateTimes(startTime, stopTime);

      /*if (this.timeAlert === null) {*/
        this.dealerService.saveDealer(this.dealer)
          .pipe(finalize(() => this.isRequesting = false))
          .subscribe(
            {
              next: (result) => {
                if (result) {
                  this.dialogRef.close(result);
                }
              },
              error: (error: string) => this.errors = error
            });
      //}
      //else {
      //  this.isRequesting = false;
      //}
    }
  }

  //buildTimeList() {
  //  this.times = new Array();
  //  for (let hour = 6; hour < 22; hour++) {
  //    for (let minute = 0; minute < 60; minute += 15) {
  //      let timeValue = new Date(1970, 0, 1, hour, minute, 0);
  //      this.times.push(this.datepipe.transform(timeValue, 'hh:mm a'));
  //    }
  //  }
  //  this.times.push('10:00 PM')
  //}

  onNoClick(): void {
    var proceed = confirm($localize`Are you sure?`);
    if (!proceed) return;

    this.dialogRef.close();
  }

}
